import { render } from "./DonateView.vue?vue&type=template&id=47e559cb&scoped=true"
const script = {}

import "./DonateView.vue?vue&type=style&index=0&id=47e559cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e559cb"]])

export default __exports__